import React from "react";
import { toast } from "react-toastify";

import { Box, FormControlLabel, Switch, Typography } from "@material-ui/core";

/**
 * Liga/desliga do Gallera Chat numa conexão (22/09/2026).
 *
 * O mesmo campo `webchatEnabled` tem um significado de cada lado:
 *  - conexão WebChat: o chat recebe clientes. Desligada = links param de abrir e quem estava
 *    com o app aberto recebe "chat desligado".
 *  - conexão de WhatsApp (qualquer motor): o convite com o link do chat sai na saudação desta
 *    conexão. Desligada = o {{link_chat}} das mensagens dela sai vazio.
 *
 * Ao ligar numa conexão de WhatsApp, a linha do convite entra na saudação (aba Mensagens),
 * visível e editável — o admin vê exatamente o que o cliente vai receber. Ao desligar, sai.
 */

export const CONVITE_PADRAO =
  "Prefere continuar por aqui, sem depender do WhatsApp? Entre no nosso chat: {{link_chat}}";

const temLink = (linha) => /\{\{\{?\s*(link_chat|linkchat|link_atendimento)\s*\}?\}\}/.test(linha);

const WebchatConnectionSwitch = ({ channel, values, setFieldValue }) => {
  const ehWebchat = channel === "webchat";
  const ligado = !!values.webchatEnabled;

  const handleChange = (e) => {
    const on = e.target.checked;
    setFieldValue("webchatEnabled", on);
    if (ehWebchat) return;

    const saudacao = String(values.greetingMessage || "");
    if (on && !temLink(saudacao)) {
      setFieldValue(
        "greetingMessage",
        saudacao.trim() ? `${saudacao.trimEnd()}\n\n${CONVITE_PADRAO}` : CONVITE_PADRAO
      );
      toast.info("Convite adicionado no fim da mensagem de saudação (aba Mensagens). Salve para valer.");
    } else if (!on && temLink(saudacao)) {
      const semConvite = saudacao
        .split("\n")
        .filter((l) => !temLink(l))
        .join("\n")
        .replace(/\n{3,}/g, "\n\n")
        .trim();
      setFieldValue("greetingMessage", semConvite);
      toast.info("Convite retirado da mensagem de saudação. Salve para valer.");
    }
  };

  return (
    <Box
      style={{
        border: `1px solid ${ligado ? "#1a8b4a" : "#9e9e9e"}`,
        background: ligado ? "rgba(26,139,74,.06)" : "transparent",
        borderRadius: 8,
        padding: "8px 12px",
        margin: "8px 0",
      }}
    >
      <FormControlLabel
        control={<Switch color="primary" checked={ligado} onChange={handleChange} />}
        label={
          <Typography style={{ fontWeight: 600 }}>
            {ehWebchat
              ? ligado
                ? "Chat ligado — clientes conseguem abrir a conversa"
                : "Chat desligado — ninguém consegue abrir a conversa"
              : ligado
                ? "Convidando clientes desta conexão para o chat próprio"
                : "Convidar clientes desta conexão para o chat próprio"}
          </Typography>
        }
      />
      <Typography variant="body2" color="textSecondary">
        {ehWebchat
          ? "É a chave geral do chat da empresa. Desligada, os links já enviados deixam de abrir e quem estiver conversando recebe o aviso para voltar ao WhatsApp. Nada é apagado: ligue de novo e tudo volta."
          : "O cliente recebe, na saudação, o link pessoal para continuar a conversa no chat próprio — sem custo de mensagem da Meta. Exige a conexão WebChat ligada. Salve a conexão para valer."}
      </Typography>
    </Box>
  );
};

export default WebchatConnectionSwitch;
